export default __webpack_public_path__ + "static/media/Reports.306b9111.svg";